import styles from "./ExportVideo.module.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { Button, createStyles, makeStyles, MenuItem, Modal, Select, CircularProgress } from "@material-ui/core";
import { UpdateExportVideoInfo, UpdateVideo } from "../../store/actions/VideoInfoActions";
import { Template } from "../../models/Template";
import PuiTypography from "../../../components/elements/PuiTypography";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { useHistory } from "react-router-dom";
/**
|--------------------------------------------------
| 動画書き出しモーダル画面
|--------------------------------------------------
*/

const useStyles = makeStyles(() =>
    createStyles({
        btnStyle: {
            height: "40px",
            minWidth: "100px"
        },
        select: {
            color: "var(--primary-font)",
            width: "100%",
            marginBottom: "25px",
            borderColor: "var(--primary-font)",

            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--primary-font)!important"
            }
        }
    })
);

export default function ExportVideo() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const {
        clipList,
        timeline,
        userInfo,
        templateList,
        updateVideoInfo,
        exportVideoInfo,
        isLoading,
        isSuccessExportVideo
    } = useSelector((state: AppState) => ({
        clipList: state.timeline.timeline?.clipList,
        timeline: state.timeline.timeline?.timeline,
        userInfo: state.user.userInfo,
        templateList: state.template.templateList,
        updateVideoInfo: state.videoInfo.updateVideoInfo,
        exportVideoInfo: state.videoInfo.exportVideoInfo,
        isLoading: state.videoInfo.isLoading,
        isSuccessExportVideo: state.videoInfo.isSuccessExportVideo,
    }));

    // 書き出しボタンを押下の場合、モーダル表示定義
    const [openUploadVideoModal, setOpenUploadVideoModal] = useState(false);

    // OPテンプレート
    const [openingTemplate, setOpeningTemplate] = useState<number>(-1);
    // EDテンプレート
    const [endingTemplate, setEndingTemplate] = useState<number>(-1);

    // OPのテンプレート設定
    const [openingTemplateList, setOpeningTemplateList] = useState<Template[]>([]);
    // EDのテンプレート設定
    const [endingTemplateList, setEndingTemplateList] = useState<Template[]>([]);
    const [isExporting, setIsExporting] = useInitFlag();

    // モーダル閉じる
    const CloseUploadVideoModal = () => {
        setOpenUploadVideoModal(false);
    };

    //書き出し実行
    const handleUpdateVideoInfo = () => {
        if (userInfo && timeline) {
            // updateVideoInfoCal();
            dispatch(UpdateVideo(updateVideoInfo));
        }
        setIsExporting(true);
        setOpenUploadVideoModal(false);
        
    };

    // OPテンプレート
    const selectOpeningTemplate = (event: any) => {
        setOpeningTemplate(event.target.value);
        dispatch(UpdateExportVideoInfo({
            ...exportVideoInfo,
            opTemplateId: Number(event.target.value)
        }));
    };

    // EDテンプレート
    const selectEndingTemplate = (event: any) => {
        setEndingTemplate(event.target.value);
        dispatch(UpdateExportVideoInfo({
            ...exportVideoInfo,
            edTemplateId: Number(event.target.value)
        }));
    };
    
    // 書き出し中メッセージ表示
    useEffect(() => {
        if (isExporting && isSuccessExportVideo) {
            // setShowExportStartMessage(true);
            // setIsCreatingVideo(true);
            // setIsExporting(false);
            history.push("/studio/homepage");
        }
        // eslint-disable-next-line
    }, [isSuccessExportVideo]);

    useEffect(() => {
        if (templateList) {
            // OPのテンプレート設定
            const tempOpeningTemplateList: Template[] = templateList.filter(
                (template) => template.type === "OP"
            );
            setOpeningTemplateList(tempOpeningTemplateList);

            // EDのテンプレート設定
            const tempEndingTemplateList: Template[] = templateList.filter(
                (template) => template.type === "ED"
            );
            setEndingTemplateList(tempEndingTemplateList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateList]);

    // 表示待機
    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress
                    size={60}
                    style={{ color: "var(--loading-bg)", marginBottom: "5px" }}
                />
                <PuiTypography>{"書き出し中です・・・"}</PuiTypography>
            </div>
        );
    }

    return (
        <>
            {/* 書き出しボタン */}
            {timeline && (
                <div
                    className={
                        `${styles.exportBtn} ${
                            !clipList || clipList.length === 0 ? styles.isBtnDisabled : ""
                        }`
                    }
                    onClick={() => setOpenUploadVideoModal(true)}
                >
                    書き出し
                </div>
            )}
            <div className={styles.root}>
                <Modal
                    aria-labelledby="spring-modal-title"
                    aria-describedby="spring-modal-description"
                    aria-hidden={false}
                    open={openUploadVideoModal}
                    onClose={CloseUploadVideoModal}
                >
                    <div className={styles.rootDiv}>
                        <form name="updateVideoForm" id="updateVideoForm" className={styles.form}>
                            {/* OPテンプレート */}
                            <div className={styles.columnStyle}>
                                <div className={styles.formTitle}>OPテンプレート</div>
                                <Select
                                    color="secondary"
                                    id="selectOpeningTemplate"
                                    variant="outlined"
                                    defaultValue="選択なし"
                                    className={classes.select}
                                    value={openingTemplate}
                                    onChange={selectOpeningTemplate}
                                >
                                    <MenuItem value={"-1"}>選択なし</MenuItem>
                                    {openingTemplateList.map((openTemp, index) => (
                                        <MenuItem key={index} value={openTemp.id}>
                                            {openTemp.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            {/* EDテンプレート */}
                            <div className={styles.columnStyle}>
                                <div className={styles.formTitle}>EDテンプレート</div>
                                <Select
                                    color="secondary"
                                    id="selectEndingTemplate"
                                    variant="outlined"
                                    defaultValue="選択なし"
                                    className={classes.select}
                                    value={endingTemplate}
                                    onChange={selectEndingTemplate}
                                >
                                    <MenuItem value={"-1"}>選択なし</MenuItem>
                                    {endingTemplateList.map((endingTemp, index) => (
                                        <MenuItem key={index} value={endingTemp.id}>
                                            {endingTemp.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </form>
                        <div className={styles.formBtn}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                className={classes.btnStyle}
                                onClick={handleUpdateVideoInfo}
                                style={{ fontSize: "15px", backgroundColor: "var(--studio-btn-bg)" }}
                            >
                                書き出し
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}
